import * as React from 'react';
import Menu from '@mui/material/Menu';
import MDButton from './MDButton';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {Box} from '@mui/material';
import {IconButton} from '@mui/material';
import { DocumentActionsMenu } from './DocumentActionsMenu/DocumentActionsMenu';

export function DataGridActionsMenu(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const rowId = props.rowId;    
    const isPaid = props.isPaid;

    const handleClick = (e) => {
      setAnchorEl(e.currentTarget);
    };

    const handleClose = (e) => {    
      setAnchorEl(null);      
      props.handleMenuOptionClick(e.currentTarget.id, rowId);
    };
  
    return (
      <Box direction="row" display="flex" justifyContent="flex-end" alignItems="flex-end" spacing={0} >       
        <MDButton     
          sx={{m:0,p:0,width:"40px", textTransform: 'none', fontWeight: 700, fontSize: '13px'}}
          color="info"
          id="edit"
          type="submit"    
          variant='text'         
          onClick={handleClose}>
          Edytuj
        </MDButton>
        <IconButton onClick={handleClick}>
            <ArrowDropDownIcon/>
        </IconButton>       
      
        <Menu
          id="grid-actions-pane-menu"
          MenuListProps={{
            'aria-labelledby': 'demo-customized-button',
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          <DocumentActionsMenu preview={props?.preview} 
            pdf={props?.pdf} 
            duplicatePdf={props?.duplicatePdf}
            invoice={props?.invoice}
            reinvoice={props?.reinvoice} 
            payment={props?.payment} 
            correction={props?.correction} 
            remove={props?.remove} 
            removeSelected={props?.removeSelected} 
            rowId={rowId} 
            isPaid={isPaid} 
            handleClose={handleClose}
          />
        </Menu>
      </Box>
    );
}  
export default DataGridActionsMenu;
